function fnProjectsFilter(i, oSection) {
  $("select", oSection).dropkick({ mobile: true });

  const toggleButton = oSection.querySelector(".toggle-button");
  const filterItems = oSection.querySelectorAll('.dk-option');

  function handleFilterItems() {
    if (window.innerWidth < 960) {
      !filterItems.initialized &&
      filterItems.forEach((item) => {
        item.addEventListener('click', () => {
          if (oSection.ariaCurrent == "true") {
            gsap.to(oSection.querySelector(".searchandfilter"), {
              display: "none",
              height: 0,
              paddingTop: 0,
              clearProps: "all",
            });
    
            oSection.ariaCurrent = false;
          } else {
            gsap.set(oSection.querySelector(".searchandfilter"), {
              display: "block",
            });
            gsap.from(oSection.querySelector(".searchandfilter"), {
              height: 0,
              paddingTop: 0,
            });
    
            oSection.ariaCurrent = true;
          }
    
          toggleButton.initialized = true;
        });
      });
    }
  }

  handleFilterItems();

  // Update on window resize
  window.addEventListener('resize', handleFilterItems);

  !toggleButton.initialized &&
    toggleButton.addEventListener("click", () => {
      if (oSection.ariaCurrent == "true") {
        gsap.to(oSection.querySelector(".searchandfilter"), {
          display: "none",
          height: 0,
          paddingTop: 0,
          clearProps: "all",
        });

        oSection.ariaCurrent = false;
      } else {
        gsap.set(oSection.querySelector(".searchandfilter"), {
          display: "block",
        });
        gsap.from(oSection.querySelector(".searchandfilter"), {
          height: 0,
          paddingTop: 0,
        });

        oSection.ariaCurrent = true;
      }

      toggleButton.initialized = true;
    });
}
